module.exports = __webpack_public_path__ + "img/door44.38a0b98f.gif";